var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M58.5 24.75H13.5C12.2574 24.75 11.25 25.7574 11.25 27V58.5C11.25 59.7426 12.2574 60.75 13.5 60.75H58.5C59.7426 60.75 60.75 59.7426 60.75 58.5V27C60.75 25.7574 59.7426 24.75 58.5 24.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 24.75H13.5C12.2574 24.75 11.25 25.7574 11.25 27V58.5C11.25 59.7426 12.2574 60.75 13.5 60.75H58.5C59.7426 60.75 60.75 59.7426 60.75 58.5V27C60.75 25.7574 59.7426 24.75 58.5 24.75Z",
    stroke: "black",
    strokeWidth: 4.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 24.75V14.625C25.875 11.9397 26.9417 9.36435 28.8405 7.46554C30.7394 5.56674 33.3147 4.5 36 4.5C38.6853 4.5 41.2606 5.56674 43.1595 7.46554C45.0583 9.36435 46.125 11.9397 46.125 14.625V24.75",
    stroke: "black",
    strokeWidth: 4.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46.125C37.864 46.125 39.375 44.614 39.375 42.75C39.375 40.886 37.864 39.375 36 39.375C34.136 39.375 32.625 40.886 32.625 42.75C32.625 44.614 34.136 46.125 36 46.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.601fbcec23ccd3ba24be1dd934a3bfa7.svg";
export { ForwardRef as ReactComponent };